import { CandidateStage } from "common/CandidateStage"
import { EditableCell } from "common/Table/EditableCell"
import { Table } from "common/Table/Table"
import { ChangeEvent, Fragment, useCallback, useEffect, useState } from "react"
import swal from "sweetalert"
import UserService from "services/user.service"
import {
  CANDIDATE_DETAILS,
  HOME_DETAILS,
  INTERVIEW_COLUMNS,
  OUTREACH,
  SCREENING,
  SOURCE_DETAILS,
} from "utils/constants"

import { buildCsvFromObjects, exportToCSV, formatDate } from "utils/funcs"
import CopyText from "common/CopyText"
import { formatPhone } from "./Contacts"
import { useDebounce } from "hooks/useDebounce"
import DatePicker from "react-datepicker"
import moment from "moment"
import { DATE } from "./trainings/WeeklyStats"
import MultiSelectDropdown from "common/form/MultiSelect"
import { useNotifications } from "hooks/useNotification"
import { Modal } from "common/Modal"
import classNames from "classnames"
import { useRouter } from "hooks/useRouter"
import { CampaignModal } from "components/CampaignModal"
import { useSelector } from "react-redux"
import { useThunkDispatch } from "hooks/useThunkDispatch"
import { clearFilters, setFilters } from "appRedux/reducers/dealerCandidateReducer"
import { AddCandidateModal } from "components/AddCandidateModal"

const service = new UserService()

const DEFAULT_STATE = {
  first_name: "",
  last_name: "",
  email: "",
  phone: "",
  social_media_ad_id: "",
  companyId: "",
  source: {
    source: "",
  },
  candidate: {
    leader_id: "",
    leader_name: "",
  },
}

export const DealerCandidates = () => {
  const columns = [
    {
      key: "FULL_NAME",
      title: "FULL NAME",
      label: "FULL NAME",
      dbColName: "full_name",
      freeze: true,
      freezeIndex: "left-0 min-w-[190px]",
      color: "bg-[#ECEEEF] text-black ",
      // render: (value: string, id: string) => (
      //   <EditableCell
      //     value={value}
      //     onBlur={(value) => updateData({ id, column: "FULL_NAME", value })}
      //   />
      // ),
    },
    {
      key: "CANDIDATE_STAGE_ICON",
      title: "CANDIDATE STAGE",
      render: (value: {
        candidate_stage: string
        first_name: string
        last_name: string
      }) => {
        return (
          <CandidateStage
            firstName={value?.first_name}
            lastName={value?.last_name}
            stage={value?.candidate_stage}
          />
        )
      },
    },
    {
      key: "EVO_STAGE",
      title: "STAGE",
      label: "EVO STAGE",
      dbColName: "stage",
    },
    {
      key: "EMAIL",
      title: "EMAIL",
      label: "EMAIL",
      dbColName: "email",
      render: (e) => <CopyText copyText={e} text={e} />,
    },
    {
      key: "phone",
      dbColName: "phone",
      title: "phone",
      render: (phone) => (
        <CopyText copyText={phone} text={formatPhone(phone)} />
      ),
    },
    {
      key: "aiFirst",
      dbColName: "aiFirst",
      title: "ai First",
    },

    {
      key: "screeningresult",
      render: (row) => {
        return (
          <div className="flex items-center ">
            <span className="text-black"> {row?.screening?.result}</span>
            <button
              onClick={() => {
                setOpenModal(true)
                setSelectedId(row._id)
                setUpdateField({
                  candidateInterest: row?.screening?.candidateInterest,
                  notes: row?.screening?.notes,
                  result: row?.screening?.result,
                })
              }}
              type="button"
              className="p-2 text-xs text-blue-500 rounded-md "
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                />
              </svg>
            </button>
          </div>
        )
      },

      title: "Screening",
      color: "bg-blue-500 text-black",
      header: (row) => (
        <div>
          <button
            type="button"
            onClick={() => setShowScreening(!showScreening)}
          >
            {showScreening ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
                />
              </svg>
            )}
          </button>
          {/* <button
            onClick={() => {
              setOpenModal(true)
              console.log(row)
              // setSelectedId(_id)
              // setUpdateField({
              //   candidateInterest: screening?.candidateInterest,
              //   notes: screening?.notes,
              //   result: screening?.result,
              // })
            }}
            type="button"
            className="p-2 text-xs text-white rounded-md "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
              />
            </svg>
          </button> */}
        </div>
      ),
    },
    {
      key: "firstCallAttempt",
      render: (row) => {
        return (
          <input
            type="checkbox"
            key={row._id}
            name="firstCallAttempt"
            onChange={(e) =>
              updateAttempts(row._id, "firstCallAttempt", e.target.checked)
            }
            defaultChecked={row?.screening["firstCallAttempt"]}
            value={row?.screening["firstCallAttempt"]}
          />
        )
      },
      title: "Called",
      show: false,
      color: "bg-blue-500 text-black",
    },
    // {key: "firstCallAttemptTimeStamp", dbColName: "screening", render: screening => screening["firstCallAttemptTimeStamp"], title: "Called", show: false , color: "bg-blue-500 text-black",},
    {
      key: "secondCallAttemp",
      render: (row) => row?.contactAttempt ?? 0,
      title: "contact Attempt",
      dbColName: "screening",
      show: false,
      color: "bg-blue-500 text-black",
    },
    // {
    //   key: "followUp",
    //   render: (row) => (
    //     <input
    //       key={row._id}
    //       type="checkbox"
    //       name="followUp"
    //       onChange={(e) =>
    //         updateAttempts(row._id, "followUp", e.target.checked)
    //       }
    //       defaultChecked={row?.screening["followUp"]}
    //     />
    //   ),
    //   title: "Follow up",
    //   show: false,
    //   color: "bg-blue-500 text-black",
    // },
    {
      key: "callAnswered",
      dbColName: "screening",
      render: (screening) => formatDate(screening?.callAnsweredTimeStamp),
      title: "call Answered timestamp",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "scheduled",
      render: (row) => {
        return (
          <input
            type="checkbox"
            key={row._id}
            name="scheduled"
            onChange={(e) =>
              updateAttempts(
                row._id,
                "result",
                e.target.checked ? "Accepted" : "Rejected"
              )
            }
            defaultChecked={row?.screening?.result === "Accepted"}
          />
        )
      },
      title: "Scheduled",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "followUpTimeStamp",
      dbColName: "screening",
      render: (screening) =>
        screening["followUpTimeStamp"]
          ? new Date(screening["followUpTimeStamp"]).toLocaleString()
          : "",
      title: "Follow up Timestamp",
      show: false,
      color: "bg-blue-500 text-black",
    },
    // {
    //   key: "thirdCallAttemptTimeStamp",
    //   dbColName: "screening",
    //   render: (screening) =>
    //     screening["thirdCallAttemptTimeStamp"]
    //       ? new Date(screening["thirdCallAttemptTimeStamp"]).toLocaleString()
    //       : "",
    //   title: "3rd Call Attempt Timestamp",
    //   show: false,
    //   color: "bg-blue-500 text-black",
    // },

    {
      key: "result",
      dbColName: "screening",
      render: (screening) => screening["callNotes"],
      title: "call notes",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "callnotests",
      dbColName: "screening",
      render: (screening) => formatDate(screening["callNotesTimeStamp"]),
      title: "call notes ts",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "date",
      dbColName: "screening",
      render: (screening) =>
        screening["date"] ? new Date(screening["date"]).toLocaleString() : "",
      title: "Most Recent Timestamp",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "result_ts",
      dbColName: "screening",
      render: (screening) =>
        screening["result_ts"]
          ? new Date(screening["result_ts"]).toLocaleString()
          : "",
      title: "result_ts",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "points",
      dbColName: "screening",
      render: (screening) => screening["points"],
      title: "points",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "points_ts",
      dbColName: "screening",
      render: (screening) => screening["points_ts"],
      title: "points_ts",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "notes",
      dbColName: "screening",
      render: (screening) => screening["notes"],
      title: "notes",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "notes_ts",
      dbColName: "screening",
      render: (screening) =>
        screening["notes_ts"]
          ? new Date(screening["notes_ts"]).toLocaleString()
          : "",
      title: "notes_ts",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "candidateInterest",
      dbColName: "screening",
      render: (screening) => screening["candidateInterest"],
      title: "candidateInterest",
      show: false,
      color: "bg-blue-500 text-black",
    },
    {
      key: "candidateInterestTimeStamp",
      dbColName: "screening",
      render: (screening) =>
        screening["candidateInterestTimeStamp"]
          ? new Date(screening["candidateInterestTimeStamp"]).toLocaleString()
          : "",
      title: "Candidate Interest Timestamp",
      show: false,
      color: "bg-blue-500 text-black",
    },

    {
      key: "outreach",
      dbColName: "outreach",
      render: (row) => row.outreach,
      color: "bg-green-500 text-black",
      title: "Outreach",
      header: () => (
        <button type="button" onClick={() => setShowOutreach((prev) => !prev)}>
          {showOutreach ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },
    {
      key: "count2",
      dbColName: "outreach",
      title: "outreach count",
      show: false,
      color: "bg-green-500 text-black",
      render: (row) => row.outreach_count,
    },
    {
      key: "outreach_ts2",
      dbColName: "outreach",
      show: false,
      title: "most recent ts",
      color: "bg-green-500 text-black",
      render: (row) => formatDate(row.outreach_ts),
    },
    {
      key: "count_ts3",
      dbColName: "outreach",
      color: "bg-green-500 text-black",
      show: false,
      title: "first attempt ts",
      render: (row) => formatDate(row.outreach_count_ts),
    },
    {
      key: "notes2",
      dbColName: "outreach",
      title: "outreach notes",
      show: false,
      color: "bg-green-500 text-black",
      render: (row) => row.notes,
    },
    //  {
    //   key: "previous2",
    //   dbColName: "outreach",
    //   title: "outreach previous",
    //   show: false,
    //   color: "bg-green-500 text-black",
    //   render: (row) => row.previous,
    // },
    {
      key: "notes_ts1",
      dbColName: "outreach",
      title: "outreach notes ts",
      color: "bg-green-500 text-black",
      show: false,
      render: (row) => formatDate(row.notes_ts),
    },

    {
      key: "interview3",
      title: "interview",
      dbColName: "interview",
      render: (interview) => interview["interview"],
      header: () => (
        <button type="button" onClick={() => setShowInterview((prev) => !prev)}>
          {showInterview ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },
    {
      key: "scheduled_date2",
      title: "scheduled_date",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["scheduled_date"],
    },
    {
      key: "scheduled_time2",
      title: "scheduled_time",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["scheduled_time"],
    },
    {
      key: "scheduled_timezone2",
      title: "scheduled_timezone",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["scheduled_timezone"],
    },
    {
      key: "interview_ts2",
      title: "interview_ts",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["interview_ts"],
    },
    {
      key: "notes566",
      title: "notes",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["notes"],
    },
    {
      key: "notes_ts123",
      title: "notes_ts",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["notes_ts"],
    },
    {
      key: "result31",
      title: "result",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["result"],
    },
    {
      key: "results_ts123",
      title: "results_ts",
      show: false,
      dbColName: "interview",
      render: (interview) => interview["results_ts"],
    },
    {
      key: "UID",
      title: "UID",
      label: "UID",
      dbColName: "uid",
      freeze: true,
      freezeIndex: "left-[210px] min-w-[150px]",
      color: "bg-[#D9F1F5] text-black",
      header: () => (
        <button type="button" onClick={() => setShowCandidate(!showCandidate)}>
          {showCandidate ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },
    {
      key: "ORIGINATION_DATE",
      title: "ORIGINATION DATE",
      label: "ORIGINATION DATE",
      dbColName: "candidate",
      render: (candidate) =>
        candidate.origination_date
          ? new Date(candidate.origination_date).toLocaleDateString()
          : "",
      color: "bg-[#4DD0E1] text-black",
      show: false,
    },
    {
      key: "CANDIDATE_TYPE",
      title: "CANDIDATE TYPE",
      label: "CANDIDATE TYPE",
      dbColName: "candidate",
      color: "bg-[#4DD0E1] text-black",
      render: (candidate) => candidate.type,
      // render: (value: string, id: string) => (
      //   <EditableCell
      //     value={value}
      //     onBlur={(value) =>
      //       updateData({ id, column: "CANDIDATE_TYPE", value })
      //     }
      //   />
      // ),
      show: false,
    },
    {
      key: "FIRST_NAME",
      title: "FIRST NAME",
      label: "FIRST NAME",
      dbColName: "first_name",
      show: false,
      color: "bg-[#4DD0E1] text-black",
      render: (value: string, id: string) => (
        <EditableCell
          value={value}
          onBlur={(value) => updateData({ id, column: "FIRST_NAME", value })}
        />
      ),
    },
    {
      key: "LAST_NAME",
      title: "LAST NAME",
      label: "LAST NAME",
      dbColName: "last_name",
      color: "bg-[#4DD0E1] text-black",
      render: (value: string, id: string) => (
        <EditableCell
          value={value}
          onBlur={(value) => updateData({ id, column: "LAST_NAME", value })}
        />
      ),
    },

    {
      key: "BIRTHDAY",
      title: "BIRTHDAY",
      label: "BIRTHDAY",
      dbColName: "birthday",
      color: "bg-[#4DD0E1] text-black",
      render: (value: string, id: string) => (
        <EditableCell
          value={value}
          onBlur={(value) => updateData({ id, column: "BIRTHDAY", value })}
        />
      ),
      show: false,
    },
    {
      key: "SOURCE",
      title: "SOURCE",
      label: "SOURCE",
      dbColName: "source",
      color: "bg-yellow-300 text-black",
      render: (source) => source?.source,
      header: () => (
        <button type="button" onClick={() => setShowSource(!showSource)}>
          {showSource ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },
    {
      key: "SOURCE_CATEGORY",
      title: "SOURCE CATEGORY",
      label: "SOURCE CATEGORY",
      dbColName: "source",
      color: "bg-yellow-300",
      render: (source) => source?.source_category,
      show: false,
    },
    {
      key: "SOURCE_ID",
      title: "SOURCE ID",
      label: "SOURCE ID",
      dbColName: "source",
      color: "bg-yellow-300",
      render: (source) => source?.source_id,
      show: false,
    },
    {
      key: "SOURCE_NOTE",
      title: "SOURCE NOTE",
      label: "SOURCE NOTE",
      dbColName: "source",
      color: "bg-yellow-300",
      render: (source) => source?.notes,
      show: false,
    },
    {
      key: "CAMPAIGN_ID",
      title: "CAMPAIGN ID",
      label: "CAMPAIGN ID",
      dbColName: "source",
      color: "bg-yellow-300",
      render: (source) => source?.campaign_id,
      show: false,
    },
    {
      key: "RECRUITING_LOCATION",
      title: "RECRUITING LOCATION",
      label: "RECRUITING LOCATION",
      dbColName: "source",
      color: "bg-yellow-300",
      render: (source) => source?.recruiting_location,
      show: false,
    },

    {
      key: "HOME_CITY",
      title: "HOME CITY & STATE",
      label: "HOME CITY",
      dbColName: "address",
      color: "bg-[#F36524]",
      header: () => (
        <button type="button" onClick={() => setShowHome(!showHome)}>
          {showHome ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
      render: (address: { city: string; state }, id: string) =>
        `${address.city}, ${address.state}`,
    },
    {
      key: "HOME_COUNTRY",
      title: "HOME COUNTRY",
      label: "HOME COUNTRY",
      dbColName: "address",
      color: "bg-[#F36524]",
      render: (address) => address.country,
    },
    {
      key: "HOME_ADDRESS",
      title: "HOME ADDRESS",
      label: "HOME ADDRESS",
      dbColName: "address",
      render: (address) => address.address,
      color: "bg-[#F36524]",
    },

    {
      key: "HOME_ZIP_CODE",
      title: "HOME ZIP CODE",
      label: "HOME ZIP CODE",
      dbColName: "address",
      color: "bg-[#F36524]",
      render: (address) => address.zip_code,
    },
    {
      key: "HOME_TIMEZONE",
      title: "HOME TIMEZONE",
      label: "HOME TIMEZONE",
      dbColName: "address",
      color: "bg-[#F36524]",
      render: (address) => address.timezone,
    },
    {
      key: "COLLEGE_NAME",
      title: "COLLEGE NAME",
      label: "COLLEGE NAME",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.name,
      header: () => (
        <button type="button" onClick={() => setShowCollege(!showCollege)}>
          {showCollege ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },
    {
      key: "COLLEGE_DEGREE_TYPE",
      title: "COLLEGE DEGREE TYPE",
      label: "COLLEGE DEGREE TYPE",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.degree_type,
    },

    {
      key: "COLLEGE_ENROLL_DATE",
      title: "COLLEGE ENROLL DATE",
      label: "COLLEGE ENROLL DATE",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.enroll_date,
    },
    {
      key: "COLLEGE_EXPECTED_GRAUDATION_YEAR",
      title: "COLLEGE EXPECTED GRAUDATION YEAR",
      label: "COLLEGE EXPECTED GRAUDATION YEAR",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.expected_graduation_year,
    },
    {
      key: "COLLEGE_MAJOR",
      title: "COLLEGE MAJOR",
      label: "COLLEGE MAJOR",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.major,
    },

    {
      key: "COLLEGE_ADDRESS",
      title: "COLLEGE ADDRESS",
      label: "COLLEGE ADDRESS",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.address,
    },
    {
      key: "COLLEGE_CITY",
      title: "COLLEGE CITY",
      label: "COLLEGE CITY",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.city,
    },
    {
      key: "COLLEGE_STATE",
      title: "COLLEGE STATE",
      label: "COLLEGE STATE",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.state,
    },
    {
      key: "COLLEGE_ZIP_CODE",
      title: "COLLEGE ZIP CODE",
      label: "COLLEGE ZIP CODE",
      dbColName: "college",
      color: "bg-[#CBA676] text-black",
      render: (college) => college.zip_code,
    },

    {
      key: "updated at",
      title: "updated at",
      label: "updated at",
      isSort: true,
      dbColName: "updatedAt",
      render: (date) => new Date(date).toLocaleString(),
    },

    {
      key: "INTERVIEWER_ID",
      title: "INTERVIEWER ID",
      label: "INTERVIEWER ID",
      dbColName: "interviewer",
      color: "bg-[#24A69A] text-black",
      render: (interviewer) => interviewer?.id,
    },
    {
      key: "INTERVIEWER_NAME",
      title: "INTERVIEWER NAME",
      label: "INTERVIEWER NAME",
      dbColName: "interviewer",
      color: "bg-[#24A69A] text-black",
      render: (interviewer) => interviewer?.name,
      header: () => (
        <button
          type="button"
          onClick={() => setShowInterviewer(!showInterviewer)}
        >
          {showInterviewer ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },

    {
      key: "INTERVIEWER_PHONE",
      title: "INTERVIEWER PHONE",
      label: "INTERVIEWER PHONE",
      render: (interviewer) => interviewer?.phone,
      dbColName: "interviewer",
      color: "bg-[#24A69A] text-black",
    },
    {
      key: "INTERVIEWER_EMAIL",
      title: "INTERVIEWER EMAIL",
      label: "INTERVIEWER EMAIL",
      dbColName: "interviewer",
      color: "bg-[#24A69A] text-black",
      render: (interviewer) => interviewer?.email,
    },
    {
      key: "INTERVIEWER_TIMEZONE",
      title: "INTERVIEWER TIMEZONE",
      render: (interviewer) => interviewer?.timezone,
      label: "INTERVIEWER TIMEZONE",
      dbColName: "interviewer",
      color: "bg-[#24A69A] text-black",
    },
    {
      key: "SALES_LEADER_ID",
      title: "SALES LEADER ID",
      label: "SALES LEADER ID",
      dbColName: "sales_leader",
      render: (sales_leader) => sales_leader.id,
      color: "bg-blue-400 text-black",
    },
    {
      key: "SALES_LEADER_NAME",
      title: "SALES LEADER NAME",
      label: "SALES LEADER NAME",
      dbColName: "sales_leader",
      render: (sales_leader) => sales_leader.name,
      color: "bg-blue-400 text-black",

      header: () => (
        <button type="button" onClick={() => setShowLeader(!showLeader)}>
          {showLeader ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
              />
            </svg>
          )}
        </button>
      ),
    },
    {
      key: "interview_sales",
      dbColName: "sales_interview",
      render: (row) => row["interview"],
      title: "sales interview",
    },
    {
      key: "interview_date_sales",
      dbColName: "sales_interview",
      render: (row) => formatDate(row["interview_date"]),
      title: "sales interview date",
    },
    {
      key: "interview_time_sales",
      dbColName: "sales_interview",
      render: (row) => row["interview_time"],
      title: "sales interview time",
    },
    {
      key: "interview_timezone_sales",
      dbColName: "sales_interview",
      render: (row) => row["interview_timezone"],
      title: "sales interview timezone",
    },
    {
      key: "interview_ts_sales",
      dbColName: "sales_interview",
      render: (row) => formatDate(row["interview_ts"]),
      title: "sales interview ts",
    },
    {
      key: "interview_notes_sales",
      dbColName: "sales_interview",
      render: (row) => row["interview_notes"],
      title: "sales interview notes",
    },
    {
      key: "result_sales",
      dbColName: "sales_interview",
      render: (row) => row["result"],
      title: "sales result",
    },
    {
      key: "result_ts_sales",
      dbColName: "sales_interview",
      render: (row) => formatDate(row["result_ts"]),
      title: "sales result ts",
    },
    {
      key: "city_sales",
      dbColName: "sales_interview",
      render: (row) => row["city"],
      title: "sales city",
    },
    {
      key: "state_sales",
      dbColName: "sales_interview",
      render: (row) => row["state"],
      title: "sales state",
    },
    {
      key: "address_sales",
      dbColName: "sales_interview",
      render: (row) => row["address"],
      title: "sales address",
    },
    {
      key: "zipcode_sales",
      dbColName: "sales_interview",
      render: (row) => row["zipcode"],
      title: "sales zipcode",
    },
    {
      key: "SALES_LEADER_PHONE",
      title: "SALES LEADER PHONE",
      label: "SALES LEADER PHONE",
      dbColName: "sales_leader",
      color: "bg-blue-400 text-black",
      render: (sales_leader) => sales_leader.phone,
    },
    {
      key: "SALES_LEADER_EMAIL",
      title: "SALES LEADER EMAIL",
      label: "SALES LEADER EMAIL",
      color: "bg-blue-400 text-black",
      dbColName: "sales_leader",
      render: (sales_leader) => sales_leader.email,
    },
    {
      key: "SALES_LEADER_TIMEZONE",
      title: "SALES LEADER TIMEZONE",
      label: "SALES LEADER TIMEZONE",
      dbColName: "sales_leader",
      color: "bg-blue-400 text-black",
      render: (sales_leader) => sales_leader.timezone,
    },
    // {
    //   key: "OUTREACH",
    //   title: "OUTREACH",
    //   label: "OUTREACH",
    //   dbColName: "outreach",
    //   render: (outreach) => outreach.outreach,
    //   color: "bg-green-300 text-black",
    // },
    // {
    //   key: "RECRUITER_NOTES",
    //   title: "OUTREACH NOTES",
    //   label: "OUTREACH NOTES",
    //   dbColName: "outreach",
    //   color: "bg-green-300 text-black",
    //   render: (outreach) => outreach.notes,
    // },
    {
      key: "INTRO_VIDEO",
      title: "INTRO VIDEO",
      label: "INTRO VIDEO",
      dbColName: "INTRO_VIDEO",
      color: "bg-green-300 text-black",
      render: (value: string, id: string) => {
        return (
          <select
            onChange={(e) =>
              updateData({ id, column: "INTRO_VIDEO", value: e.target.value })
            }
            defaultValue={value}
            className={tabStyles.cellSelect}
          >
            <option value="">Select</option>
            <option value="Sent">Sent</option>
            <option value="Started">Started</option>
            <option value="Finished">Finished</option>
          </select>
        )
      },
    },
    {
      key: "FOLLOW_UP",
      title: "FOLLOW UP",
      label: "FOLLOW UP",
      dbColName: "follow_up",
      color: "bg-green-300 text-black",
      render: (follow) => follow.follow_up,
    },
    {
      key: "FOLLOW_UP_CALL_DATE",
      title: "FOLLOW UP CALL DATE",
      label: "FOLLOW UP CALL DATE",
      color: "bg-green-300 text-black",
      dbColName: "follow_up",
      render: (follow) => follow.call_date,
    },
    {
      key: "FOLLOW_UP_CALL_TIME",
      title: "FOLLOW UP CALL TIME",
      label: "FOLLOW UP CALL TIME",
      dbColName: "follow_up",
      render: (follow) => follow.call_time,
      color: "bg-green-300 text-black",
    },
    {
      key: "FOLLOW_UP_CANDIDATE_TIME_ZONE",
      title: "FOLLOW UP CANDIDATE TIME ZONE",
      label: "FOLLOW UP CANDIDATE TIME ZONE",
      dbColName: "follow_up",
      color: "bg-green-300 text-black",
      render: (follow) => follow.follow_timzone,
    },

    {
      key: "FOLLOW_UP_NOTES",
      title: "FOLLOW UP NOTES",
      label: "FOLLOW UP NOTES",
      dbColName: "follow_up",
      color: "bg-green-300 text-black",
      render: (follow) => follow?.notes,
    },
    {
      key: "CANDIDATE_INTEREST",
      title: "CANDIDATE INTEREST",
      label: "CANDIDATE INTEREST",
      dbColName: "candidate_interest",
      color: "bg-blue-500 text-black",
      render: (candidate) => candidate.interest,
    },
    {
      key: "recuriter_interest",
      label: "Recuriter Interest",
      dbColName: "recruiter_interest",
      title: "Recuriter Interest",
      render: (recuriter) => recuriter?.interest,
    },
    {
      key: "statuss",
      title: "candidates status",
      label: "RECRUITER INTEREST",
      dbColName: "candidate_interest",
      color: "bg-blue-500 text-black",

      render: (candidate) => candidate.candidate_status,
    },

    {
      key: "INTERVIEW",
      title: "INTERVIEW",
      label: "INTERVIEW",
      dbColName: "interview",
      render: (interview) => interview.interview,
      color: "bg-[#8989EB] text-black",
    },
    {
      key: "INTERVIEW_SCHEDULED_DATE",
      title: "INTERVIEW SCHEDULED DATE",
      label: "INTERVIEW SCHEDULED DATE",
      dbColName: "interview",
      color: "bg-[#8989EB] text-black",
      render: (interview) => interview.interview_date,
    },
    {
      key: "INTERVIEW_SCHEDULED_TIME",
      title: "INTERVIEW SCHEDULED TIME",
      label: "INTERVIEW SCHEDULED TIME",
      dbColName: "interview",
      color: "bg-[#8989EB] text-black",
      render: (interview) => interview.interview_time,
    },
    {
      key: "INTERVIEW_SCHEDULED_C_TIMEZONE",
      title: "INTERVIEW SCHEDULED C-TIMEZONE",
      label: "INTERVIEW SCHEDULED C-TIMEZONE",
      dbColName: "interview",
      color: "bg-[#8989EB] text-black",
      render: (interview) => interview.interview_timezone,
    },

    {
      key: "INTERVIEW_NOTES",
      title: "INTERVIEW NOTES",
      label: "INTERVIEW NOTES",
      dbColName: "interview",
      color: "bg-[#8989EB] text-black",
      render: (interview) => interview.interview_notes,
    },
    {
      key: "INTERVIEW_RESULT",
      title: "INTERVIEW RESULT",
      label: "INTERVIEW RESULT",
      dbColName: "interview",
      color: "bg-[#8989EB] text-black",
      render: (interview) => interview.result,
    },
    // {
    //   key: "AGREEMENT_SENT_DATE",
    //   title: "AGREEMENT SENT DATE",
    //   label: "AGREEMENT SENT DATE",
    //   dbColName: "aggrement",
    //   color: "bg-[#F36524] text-black",
    //   render: (aggrement) => aggrement?.sent_date,
    // },
    // {
    //   key: "SIGNED",
    //   title: "SIGNED",
    //   label: "SIGNED",
    //   dbColName: "aggrement",
    //   color: "bg-[#F36524] text-black",
    //   render: (aggrement) => aggrement?.signed,
    // },
    // {
    //   key: "ONBOARDED",
    //   title: "ONBOARDED",
    //   label: "ONBOARDED",
    //   dbColName: "onboarding",
    //   color: "bg-[#F36524] text-black",
    //   render: (onboarding) => onboarding?.onboarded,
    // },
    // {
    //   key: "STREET_GENIE_LOGIN",
    //   title: "STREET GENIE LOGIN",
    //   label: "STREET GENIE LOGIN",
    //   dbColName: "candidate",
    //   color: "bg-[#F36524] text-black",
    //   render: (candidate) => candidate?.street_genie_login,
    // },
    // {
    //   key: "SALES_TRAINING",
    //   title: "SALES TRAINING",
    //   label: "SALES TRAINING",
    //   dbColName: "candidate",
    //   color: "bg-[#F36524] text-black",
    //   render: (candidate) => candidate?.sales_training,
    // },
    // {
    //   key: "ASSIGN_CANDIDATE_BID",
    //   title: "Employee id",
    //   label: "ASSIGN CANDIDATE BADGE ID",
    //   dbColName: "candidate",
    //   color: "bg-[#F8CA4D]",
    //   render: (candidate) => candidate?.badgeid,
    // },
    // {
    //   key: "BOOTCAMP",
    //   title: "BOOTCAMP",
    //   label: "BOOTCAMP",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp?.bootcamp,
    //   header: () => (
    //     <button type="button" onClick={() => setShowBootcamp(!showBootcamp)}>
    //       {showBootcamp ? (
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           fill="none"
    //           viewBox="0 0 24 24"
    //           strokeWidth={1.5}
    //           stroke="currentColor"
    //           className="w-4 h-4"
    //         >
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M19.5 12h-15m0 0l6.75 6.75M4.5 12l6.75-6.75"
    //           />
    //         </svg>
    //       ) : (
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           fill="none"
    //           viewBox="0 0 24 24"
    //           strokeWidth={1.5}
    //           stroke="currentColor"
    //           className="w-4 h-4"
    //         >
    //           <path
    //             strokeLinecap="round"
    //             strokeLinejoin="round"
    //             d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"
    //           />
    //         </svg>
    //       )}
    //     </button>
    //   ),
    // },
    // {
    //   key: "BOOTCAMP_TYPE",
    //   title: "BOOTCAMP TYPE",
    //   label: "BOOTCAMP TYPE",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp?.type,
    // },
    // {
    //   key: "BOOTCAMP_SCHEDULED_DATE",
    //   title: "BOOTCAMP SCHEDULED DATE",
    //   label: "BOOTCAMP SCHEDULED DATE",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp?.scheduled_date,
    // },
    // {
    //   key: "BOOTCAMP_SCHEDULED_TIME",
    //   title: "BOOTCAMP SCHEDULED TIME",
    //   label: "BOOTCAMP SCHEDULED TIME",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp?.scheduled_time,
    // },
    // {
    //   key: "BOOTCAMP_TIMEZONE",
    //   title: "BOOTCAMP TIMEZONE",
    //   label: "BOOTCAMP TIMEZONE",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp.timezone,
    // },
    // {
    //   key: "BOOTCAMP_ADDRESS",
    //   title: "BOOTCAMP ADDRESS",
    //   label: "BOOTCAMP ADDRESS",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp.address,
    // },
    // {
    //   key: "BOOTCAMP_NOTES",
    //   title: "BOOTCAMP NOTES",
    //   label: "BOOTCAMP NOTES",
    //   dbColName: "bootcamp",
    //   color: "bg-primary text-black",
    //   render: (bootcamp) => bootcamp.notes,
    // },

    {
      key: "EMPLOYEE_ID",
      title: "Leader ID",
      label: "EMPLOYEE ID",
      dbColName: "candidate",
      color: "bg-[#46818D] text-black",
      render: (candidate) => candidate.leader_id,
    },
    {
      key: "RECRUITER_NAME",
      title: "Leader NAME",
      label: "RECRUITER NAME",
      dbColName: "candidate",
      color: "bg-[#46818D] text-black",
      render: (candidate) => candidate.leader_name,
    },
    {
      key: "leader_phone",
      title: "Leader Phone",
      label: "NAME",
      dbColName: "candidate",
      color: "bg-[#46818D] text-black",
      render: (candidate) => candidate.leader_phone_number,
    },
    {
      key: "RECRUITER_email",
      title: "Email ",
      label: "email",
      dbColName: "candidate",
      color: "bg-[#46818D] text-black",
      render: (candidate) => candidate.leader_email,
    },
    // {
    //   key: "TEAM_NAME",
    //   title: "TEAM NAME",
    //   label: "TEAM NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.team_name,
    // },
    // {
    //   key: "MGMT_GROUP_NAME",
    //   title: "MGMT GROUP NAME",
    //   label: "MGMT GROUP NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.mgmt_group_name,
    // },
    // {
    //   key: "SR_MGMT_GROUP_NAME",
    //   title: "SR MGMT GROUP NAME",
    //   label: "SR MGMT GROUP NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.sr_mgmt_group_name,
    // },
    // {
    //   key: "REGION_NAME",
    //   title: "REGION NAME",
    //   label: "REGION NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.region_name,
    // },
    // {
    //   key: "SENIOR_REGION_NAME",
    //   title: "SENIOR REGION NAME",
    //   label: "SENIOR REGION NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.senior_region_name,
    // },
    // {
    //   key: "PARTNERSHIP_NAME",
    //   title: "PARTNERSHIP NAME",
    //   label: "PARTNERSHIP NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.partnership_name,
    // },
    // {
    //   key: "DIVISION_NAME",
    //   title: "DIVISION NAME",
    //   label: "DIVISION NAME",
    //   dbColName: "candidate",
    //   color: "bg-[#46818D] text-black",
    //   render: (candidate) => candidate.division_name,
    // },
    {
      key: "createdAt",
      title: "created At",
      dbColName: "createdAt",
      color: "bg-[#46818D] text-black",
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      key: "actions",
      title: "Actions",
      freeze: true,
      freezeIndex: "right-0",
      render: ({ _id, first_name, last_name, email, phone, screening }) => (
        <div>
          <button
            type="button"
            className="pl-3 text-right text-red-500"
            onClick={() => handleDelete(_id)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
              />
            </svg>
          </button>
          <button
            onClick={() => {
              setEditModal(true)
              setSelectedId(_id)
              setCandidate({
                first_name,
                last_name,
                email,
                phone,
              })
            }}
            type="button"
            className="p-2 text-xs text-blue-500 rounded-md "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ]

  const [data, setData] = useState([])
  const [showCandidate, setShowCandidate] = useState(false)
  const [showTimeStamp, setShowTimeStamp] = useState(false)
  const [showSource, setShowSource] = useState(false)
  const [state, setState] = useState(DEFAULT_STATE)
  const [showHome, setShowHome] = useState(false)
  const [showCollege, setShowCollege] = useState(false)
  const [ads, setAds] = useState([])
  const [showInterview, setShowInterview] = useState(false)
  const [showInterviewer, setShowInterviewer] = useState(false)
  const [addModal, setAddModal] = useState(false)
  const [showBootcamp, setShowBootcamp] = useState(false)
  const [showOutreach, setShowOutreach] = useState(false)
  const [showLeader, setShowLeader] = useState(false)
  const [updating, setUpdating] = useState(false)
  const [candidate, setCandidate] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  })
  const [loading, setLoading] = useState(false)
  const [totalItems, setTotalItems] = useState(0)
  const [openModal, setOpenModal] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [updateField, setUpdateField] = useState({
    candidateInterest: "",
    notes: "",
    result: "",
  })
  const [exportData, setExportData] = useState([])
  const [companyUsers, setCompanyUsers] = useState([])
  const [showScreening, setShowScreening] = useState(false)
  const [companies, setCompanies] = useState([])
  const [hoverRating, setHoverRating] = useState(0)
  const [exporting, setExporting] = useState(false)
  const [filterData, setFilterData] = useState<any>(null)
  const [editModal, setEditModal] = useState(false)
  const [selectedId, setSelectedId] = useState("")

  const filters = useSelector((state: any) => state.dealerFilters)
  const { user } = useSelector((state: any) => state.user)

  const [pagination, setPagination] = useState({
    pageNumber: filters.pageNumber || 1,
    fullName: filters.fullName || "",
    screenContactAttempt: "",
    pageSize: filters.pageSize || 100,
    companyId: filters.companyId || "",
    campaignId: filters.campaignId || "",
    aiFirst: filters?.aiFirst || "",
    leaderId: filters.leaderId || "",
    acceptedCandidate: filters.acceptedCandidate || "",
    // evoStage: "",
    // origination_date: "",
    // homeCity: "",
    // homeState: "",
    // outreach: "",
    // recruitingCategory: "",
    candidateStage: filters.candidateStage || "",
    // recruitingLocation: "",
    date: filters.date || "YEARTODATE",
    candidateEmail: filters.candidateEmail || "",
    phoneNumber: filters.phoneNumber || "",
    isDownload: filters.isDownload || false,
    // source: "",
    // sourceCategory: "",
  })

  const [sources, setSources] = useState<{ value: string; label: string }[]>([])
  const [startDate, setStartDate] = useState(null)
  const [endDate, setEndDate] = useState(null)
  const [campanignModal, setCampaignModal] = useState(false)

  const debounced = useDebounce(pagination, 1000)
  const dispatch = useThunkDispatch()
  const { push } = useRouter()
  const { errorMessage, successMessage } = useNotifications()

  const updateData = (data: any) => {
    service
      .updateColumn(data)
      .then((resp) => {
        alert("Data Updated successfully")
      })
      .catch((err) => console.error(err))
  }

  const updateAttempts = (id, col, value) => {
    service
      .updateAttempts(id, {
        [col]: value,
        userId: user?._id,
        email: user?.email,
        fullName: user?.fullname,
      })
      .then((resp) => {
        successMessage("Attempts updated successfully")
      })
      .catch((err) => console.error(err))
  }

  useEffect(() => {
    service
      .dealersMediaAds({ companyId: debounced.companyId, pageSize: 1000 })
      .then((resp) => {
        setAds(resp.data.data)
      })
      .catch((error) => console.log(error))
  }, [debounced.companyId])

  useEffect(() => {
    dispatch(setFilters(debounced))
  }, [debounced, dispatch])

  const fetchData = useCallback(() => {
    setLoading(true)
    service
      .dealerCandidates(debounced)
      .then((resp) => {
        setData(resp.data.data)
        setTotalItems(resp.data.totalDocument)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [debounced])

  const fetchComapnies = useCallback(() => {
    setLoading(true)
    service
      .getCompanies()
      .then((resp) => {
        setCompanies(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    fetchComapnies()
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const onClickExport = async () => {
    // setExporting(true)
    // service
    //   .getCanidates({
    //     ...pagination,
    //     pageSize: "",
    //     pageNumber: "",
    //     isDownload: "true",
    //   })
    //   .then((resp) => {
    //     setExportData(resp.data.data)
    //     const mapData = resp.data.data.map((obj) => ({
    //       full_name: obj.full_name,
    //       "source.recruiting_category": obj.source?.recruiting_location ?? "",
    //       "candidate.evo_stage": obj.candidate?.evo_stage ?? "",
    //       email: obj.email,
    //       uid: obj.uid,
    //       phone: obj.phone,
    //       "candidate.origination_date": obj.candidate?.origination_date ?? "",
    //       "candidate.type": obj.candidate?.type ?? "",
    //       first_name: obj.first_name,
    //       last_name: obj.last_name,
    //       birthday: obj.birthday ?? "",
    //       "source.source": obj.source?.source ?? "",
    //       "source.source_category": obj.source?.source_category ?? "",
    //       "source.source_id": obj.source?.source_id ?? "",
    //       "source.notes": obj.source?.notes ?? "",
    //       "source.campaign_id": obj.source?.campaign_id ?? "",
    //       "source.recruiting_location": obj.source?.recruiting_location ?? "",
    //       "address.city": obj.address?.city ?? "",
    //       "address.state": obj.address?.state ?? "",
    //       "address.country": obj.address?.country ?? "",
    //       "address.address": obj.address?.address ?? "",
    //       "address.zip_code": obj.address?.zip_code ?? "",
    //       "address.timezone": obj.address?.timezone ?? "",
    //       "college.name": obj.college?.name ?? "",
    //       "college.degree_type": obj.college?.degree_type ?? "",
    //       "college.enroll_date": obj.college?.enroll_date ?? "",
    //       "college.expected_graduation_year":
    //         obj.college?.expected_graduation_year ?? "",
    //       "college.major": obj.college?.major ?? "",
    //       "college.address": obj.college?.address ?? "",
    //       "college.city": obj.college?.city ?? "",
    //       "college.state": obj.college?.state ?? "",
    //       "college.zip_code": obj.college?.zip_code ?? "",
    //       recent_ts: obj.recent_ts ?? "",
    //       "interviewer.id": obj.interviewer?.id ?? "",
    //       "interviewer.name": obj.interviewer?.name ?? "",
    //       "interviewer.phone": obj.interviewer?.phone ?? "",
    //       "interviewer.email": obj.interviewer?.email ?? "",
    //       "interviewer.timezone": obj.interviewer?.timezone ?? "",
    //       "sales_leader.id": obj.sales_leader?.id ?? "",
    //       "sales_leader.name": obj.sales_leader?.name ?? "",
    //       "sales_leader.phone": obj.sales_leader?.phone ?? "",
    //       "sales_leader.email": obj.sales_leader?.email ?? "",
    //       "sales_leader.timezone": obj.sales_leader?.timezone ?? "",
    //       "outreach.outreach": obj.outreach?.outreach ?? "",
    //       "outreach.notes": obj.outreach?.notes ?? "",
    //       "outreach.notes_ts": obj.outreach?.notes_ts ?? "",
    //       "outreach.outreach_ts": obj.outreach?.outreach_ts ?? "",
    //       "follow_up.follow_up": obj.follow_up?.follow_up ?? "",
    //       "follow_up.follow_ts": obj.follow_up?.follow_ts ?? "",
    //       "follow_up.call_date": obj.follow_up?.call_date ?? "",
    //       "follow_up.call_time": obj.follow_up?.call_time ?? "",
    //       "follow_up.call_ts": obj.follow_up?.call_ts ?? "",
    //       "follow_up.follow_timezone": obj.follow_up?.follow_timezone ?? "",
    //       "follow_up.notes": obj.follow_up?.notes ?? "",
    //       "screening.date": obj.screening?.date ?? "",
    //       "screening.result": obj.screening?.result ?? "",
    //       "screening.result_ts": obj.screening?.result_ts ?? "",
    //       "screening.points": obj.screening?.points ?? "",
    //       "screening.notes": obj.screening?.notes ?? "",
    //       "screening.notes_ts": obj.screening?.notes_ts ?? "",
    //       "interview.interview": obj.interview?.interview ?? "",
    //       "interview.scheduled_date": obj.interview?.scheduled_date ?? "",
    //       "interview.scheduled_time": obj.interview?.scheduled_time ?? "",
    //       "interview.scheduled_timezone":
    //         obj.interview?.scheduled_timezone ?? "",
    //       "interview.interview_ts": obj.interview?.interview_ts ?? "",
    //       "interview.notes": obj.interview?.notes ?? "",
    //       "interview.notes_ts": obj.interview?.notes_ts ?? "",
    //       "interview.result": obj.interview?.result ?? "",
    //       "interview.results_ts": obj.interview?.results_ts ?? "",
    //       // ...obj
    //     }))
    //     exportToCSV(mapData, "recuriting")
    //   })
    //   .catch((error) => {
    //     console.log(error)
    //   })
    //   .finally(() => {
    //     setExporting(false)
    //   })

    setExporting(true)

    try {
      const response = await service.dealerCandidates({
        ...pagination,
        pageSize: "",
        pageNumber: "",
        isDownload: "true",
      })

      const rows = response.data?.data
      if (!Array.isArray(rows) || rows.length === 0) {
        errorMessage("No candidates to export")
        return
      }
      const csvContent = buildCsvFromObjects(rows)
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement("a")
      link.href = url
      link.setAttribute("download", "export.csv")
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Error downloading CSV:", error)
      errorMessage("Could not export candidates")
    } finally {
      setExporting(false)
    }
  }

  const handleDelete = (id) => {
    swal({
      title: "Are you sure, you want to delete this candidate?",
      icon: "warning",
      className: "w-[500px]",
      buttons: {
        cancel: {
          text: "Cancel",
          visible: true,
        },
        confirm: {
          text: "Delete",
          className: "bg-primary text-white",
        },
      },
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        service
          .deleteAdCandidate(id)
          .then((resp) => {
            if (resp.data.success) {
              successMessage("Dealer candidate deleted successfully")
              const index = data.findIndex(
                (item: { _id: string }) => item._id === id
              )
              const shallowCopy = [...data]
              shallowCopy.splice(index, 1)
              setData(shallowCopy)
            }
          })
          .catch((error) => console.log(error))
      }
    })
  }

  const handleStarHover = (starValue) => {
    setHoverRating(starValue)
  }

  const handleMouseLeave = () => {
    setHoverRating(0)
  }

  const handleUpdateFields = (e) => {
    e.preventDefault()

    service
      .updateAttempts(selectedId, updateField)
      .then((resp) => {
        if (resp.data.success) {
          successMessage("Candidate updated successfully")
          setOpenModal(false)
          fetchData()
        }
      })
      .catch((error) => console.error(error))
  }

  const resetFilters = () => {
    setPagination({
      pageNumber: 1,
      fullName: "",
      screenContactAttempt: "",
      campaignId: "",
      companyId: "",
      aiFirst: "",
      pageSize: 100,
      leaderId: "",
      isDownload: false,
      // origination_date: "",
      // homeCity: "",
      // evoStage: "",
      // homeState: "",
      candidateStage: "",
      acceptedCandidate: "",
      // outreach: "",
      date: "",
      // recruitingCategory: "",
      // recruitingLocation: "",
      // source: "",
      candidateEmail: "",
      phoneNumber: "",
      // sourceCategory: "",
    })
    dispatch(clearFilters())
    setSources([])
  }

  const handleChangePhone = (e) => {
    let input = e.target.value

    // Remove any non-digit characters
    input = input.replace(/\D/g, "")

    // Limit to 10 digits maximum
    if (input.length > 10) {
      input = input.slice(0, 10)
    }

    setCandidate({ ...candidate, phone: input })
  }

  const handleKeyPress = (e) => {
    // Only allow digits
    if (
      !/\d/.test(e.key) &&
      !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
    ) {
      e.preventDefault()
    }
  }

  const handleChangeCompany = (event) => {
    const id = event.target.value
    const findCompany: any = companies.find(
      (company: { companyId: string }) => company.companyId === id
    )
    const badgeid = findCompany?.owner?.badgeId || ""

    setState({
      ...state,
      companyId: id,
    })
    service
      .companyUsers(id, badgeid || "")
      .then((resp) => {
        setCompanyUsers(resp.data.data)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleUpdateCandidate = (e) => {
    e.preventDefault()
    setUpdating(true)
    service
      .updateCandidate({ id: selectedId, ...candidate })
      .then((resp) => {
        fetchData()
        // const shallowCopy = [...data]
        // shallowCopy.forEach((item: any) => {
        //   if (item._id === selectedId) {
        //     item.first_name = candidate.first_name
        //     item.last_name = candidate.last_name
        //     item.email = candidate.email
        //     item.phone = candidate.phone
        //   }
        // })
        // setData(shallowCopy)
        successMessage("Candidate upadted successfully")
        setEditModal(false)
        setCandidate({
          first_name: "",
          email: "",
          last_name: "",
          phone: "",
        })
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        setUpdating(false)
      })
  }

  const filteredData = data?.filter(
    (item: { aiFirst: string; screening: { result: string } }) =>
      !["Accepted", "Rejected"].includes(item.screening.result) &&
      item.aiFirst !== "Yes"
  )

  return (
    <Fragment>
      <div className="flex items-center justify-between">
        <div className="flex flex-col mb-4">
          <h1 className="page-title">
            Dealer Candidates
          </h1>
          <p className="page-subtitle">View all dealer candidates</p>
        </div>
        <div className="flex gap-2">
          <button
            onClick={() => setAddModal(true)}
            className="btn-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v12m6-6H6"
              />
            </svg>
            Add Candidate
          </button>
          <button
            onClick={() => {
              if (!pagination.companyId) {
                errorMessage("Please select at least one company")
              } else if (filteredData.length === 0) {
                errorMessage("Screening is completed")
              } else {
                setCampaignModal(true)
              }
            }}
            className="btn-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v12m6-6H6"
              />
            </svg>
            Start Campaign
          </button>
          <button
            onClick={() => push("/dealer-reports")}
            className="btn-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
              />
            </svg>
            Dealer Report
          </button>
        </div>
      </div>

      <Table
        data={data}
        loadingData={loading}
        setPagination={setPagination}
        pagination={pagination}
        totalItems={totalItems}
        handleExport={onClickExport}
        showSearch={false}
        setData={setData}
        exporting={exporting}
        exportData={exportData}
        filters={
          <HeaderFilter
            pagination={pagination}
            startDate={startDate}
            resetFilters={resetFilters}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            setPagination={setPagination}
          />
        }
        columnFilters={
          <ColumnFilters
            companies={companies}
            filterData={filterData}
            sources={sources}
            ads={ads}
            setAds={setAds}
            setSources={setSources}
            pagination={pagination}
            setPagination={setPagination}
          />
        }
        columns={columns.map((item: any) => {
          if (OUTREACH.includes(item.key)) {
            return {
              ...item,
              show: showOutreach,
            }
          }

          if (CANDIDATE_DETAILS.includes(item.title)) {
            return {
              ...item,
              show: showCandidate,
            }
          }
          if (SOURCE_DETAILS.includes(item.title)) {
            return {
              ...item,
              show: showSource,
            }
          }

          if (INTERVIEW_COLUMNS.includes(item.key)) {
            return {
              ...item,
              show: showInterview,
            }
          }

          if (
            item?.title?.includes("INTERVIEWER") &&
            item?.title !== "INTERVIEWER NAME"
          ) {
            return {
              ...item,
              show: showInterviewer,
            }
          }

          if (
            item?.title?.includes("COLLEGE") &&
            item.title !== "COLLEGE NAME"
          ) {
            return {
              ...item,
              show: showCollege,
            }
          }

          if (HOME_DETAILS.includes(item?.title)) {
            return {
              ...item,
              show: showHome,
            }
          }

          if (item?.title?.includes("TS") && item?.title !== "MOST RECENT TS") {
            return {
              ...item,
              show: showTimeStamp,
            }
          }
          if (item?.title?.includes("BOOTCAMP") && item?.title !== "BOOTCAMP") {
            return {
              ...item,
              show: showBootcamp,
            }
          }

          if (SCREENING.includes(item.title)) {
            return {
              ...item,
              show: showScreening,
            }
          }

          if (
            item?.title?.includes("LEADER") &&
            item?.title !== "SALES LEADER NAME"
          ) {
            return {
              ...item,
              show: showLeader,
            }
          }
          return item
        })}
      />

      <CampaignModal
        showModal={campanignModal}
        setShowScreening={setShowScreening}
        setShowModal={setCampaignModal}
        setData={setData}
        fetchData={fetchData}
        filteredData={filteredData}
        data={data}
      />

      <AddCandidateModal
        setAddModal={setAddModal}
        addModal={addModal}
        fetchData={fetchData}
      />

      <Modal
        title="Update candidate"
        showModal={editModal}
        setShowModal={setEditModal}
        width="w-full md:w-1/3"
      >
        <form
          onSubmit={handleUpdateCandidate}
          className="grid grid-cols-2 gap-4"
        >
          <div className="flex flex-col gap-1.5">
            <label>First Name</label>
            <input
              type="text"
              value={candidate?.first_name}
              onChange={(e) =>
                setCandidate({
                  ...candidate,
                  first_name: e.target.value,
                })
              }
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label>Last Name</label>
            <input
              type="text"
              value={candidate?.last_name}
              onChange={(e) =>
                setCandidate({
                  ...candidate,
                  last_name: e.target.value,
                })
              }
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label>Email</label>
            <input
              type="text"
              value={candidate?.email}
              onChange={(e) =>
                setCandidate({
                  ...candidate,
                  email: e.target.value,
                })
              }
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <div className="flex flex-col gap-1.5">
            <label>Phone</label>
            <input
              type="text"
              value={candidate?.phone}
              onChange={handleChangePhone}
              onKeyDown={handleKeyPress}
              className="w-full px-3 py-2 text-sm"
            />
          </div>

          <button
            type="submit"
            className="col-span-2 py-2 text-white bg-ink hover:bg-gray-800 rounded-lg"
          >
            {updating ? "Updating..." : "Update"}
          </button>
        </form>
      </Modal>

      <Modal
        width="w-full md:w-1/3"
        showModal={openModal}
        setShowModal={setOpenModal}
        title="Update Candidate"
      >
        <form onSubmit={handleUpdateFields} className="flex flex-col gap-4">
          <div className="flex items-center justify-between">
            <label className="field-label">Screening Result</label>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() =>
                  setUpdateField({ ...updateField, result: "Accepted" })
                }
                className="flex flex-col items-center gap-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className={classNames(
                    "w-6 h-6 text-gray-600 hover:text-green-500 hover:fill-current",
                    {
                      "text-green-500 fill-current":
                        updateField.result === "Accepted",
                    }
                  )}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6.633 10.25c.806 0 1.533-.446 2.031-1.08a9.041 9.041 0 0 1 2.861-2.4c.723-.384 1.35-.956 1.653-1.715a4.498 4.498 0 0 0 .322-1.672V2.75a.75.75 0 0 1 .75-.75 2.25 2.25 0 0 1 2.25 2.25c0 1.152-.26 2.243-.723 3.218-.266.558.107 1.282.725 1.282m0 0h3.126c1.026 0 1.945.694 2.054 1.715.045.422.068.85.068 1.285a11.95 11.95 0 0 1-2.649 7.521c-.388.482-.987.729-1.605.729H13.48c-.483 0-.964-.078-1.423-.23l-3.114-1.04a4.501 4.501 0 0 0-1.423-.23H5.904m10.598-9.75H14.25M5.904 18.5c.083.205.173.405.27.602.197.4-.078.898-.523.898h-.908c-.889 0-1.713-.518-1.972-1.368a12 12 0 0 1-.521-3.507c0-1.553.295-3.036.831-4.398C3.387 9.953 4.167 9.5 5 9.5h1.053c.472 0 .745.556.5.96a8.958 8.958 0 0 0-1.302 4.665c0 1.194.232 2.333.654 3.375Z"
                  />
                </svg>
                <span className="text-xs">Accept</span>
              </button>
              <button
                type="button"
                onClick={() =>
                  setUpdateField({ ...updateField, result: "Rejected" })
                }
                className="flex flex-col items-center gap-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className={classNames(
                    "w-6 h-6 text-gray-600 hover:text-red-500 hover:fill-current",
                    {
                      "text-red-500 fill-current":
                        updateField.result === "Rejected",
                    }
                  )}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54"
                  />
                </svg>

                <span className="text-xs">Reject</span>
              </button>
            </div>
          </div>
          <div className="flex-1 flex items-center justify-between gap-1.5">
            <label className="field-label">Candidate Interest</label>
            <div className="flex justify-center">
              {["1", "2", "3"].map((star) => (
                <button
                  type="button"
                  key={star}
                  onClick={() =>
                    setUpdateField({ ...updateField, candidateInterest: star })
                  }
                  onMouseEnter={() => handleStarHover(star)}
                  onMouseLeave={handleMouseLeave}
                  className="p-1 transition-transform duration-150 rounded-full focus:outline-none hover:scale-110"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className={`w-6 h-6 transition-colors  ${
                      star <= (hoverRating || updateField.candidateInterest)
                        ? "text-yellow-400 fill-current"
                        : "text-gray-600 hover:text-yellow-200"
                    }`}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z"
                    />
                  </svg>
                </button>
              ))}
            </div>
          </div>
          <div className="flex-1 flex flex-col gap-1.5 min-w-[150px]">
            <label className="field-label">Notes</label>
            <textarea
              placeholder="Notes"
              onChange={(e) =>
                setUpdateField({ ...updateField, notes: e.target.value })
              }
              value={updateField.notes}
              className="w-full px-3 py-2 text-sm"
            />
          </div>
          <button type="submit" className="btn-dark">
            Update
          </button>
        </form>
      </Modal>
    </Fragment>
  )
}

const ColumnFilters = ({
  filterData,
  sources,
  setSources,
  pagination,
  companies,
  ads,
  setAds,
  setPagination,
}) => {
  const handleChange = (
    event: ChangeEvent<HTMLSelectElement | HTMLInputElement>
  ) => {
    const { name, value } = event.target

    setPagination({
      ...pagination,
      [name]: value,
    })
  }

  const handleChangeCompany = (event) => {
    const id = event.target.value
    setPagination({
      ...pagination,
      companyId: id,
      campaignId: "",
    })
    // const findCompany: any = companies.find(
    //   (company: { companyId: string }) => company.companyId === id
    // )
    // const badgeid = findCompany?.owner?.badgeId || ""
  }

  // const evoStages = [
  //   { id: "Contact", label: "Contact" },
  //   { id: "Contact+", label: "Contact+" },
  //   { id: "Recruiter", label: "Recruiter" },
  //   { id: "Recruiter+", label: "Recruiter+" },
  //   { id: "Signed", label: "Signed" },
  //   { id: "Signed+", label: "Signed+" },
  //   { id: "SH Pro", label: "SH Pro" },
  //   { id: "SH Pro+", label: "SH Pro+" },
  // ];

  const allSources = [
    // { id: "Breezy", label: "Breezy" },
    { id: "Social Media", label: "Social Media" },
    { id: "User", label: "User" },
    // { id: "Elite", label: "Elite" },
    // { id: "Source", label: "Source" },
    // { id: "Paid AD", label: "Paid AD" },
    // { id: "Info Session", label: "Info Session" },
    // { id: "CampusReel", label: "CampusReel" },
    // { id: "Job Site Ad", label: "Job Site Ad" },
    { id: "Indeed", label: "Indeed" },
    // { id: "IndeedSponsored", label: "IndeedSponsored" },
    // { id: "Scholarship", label: "Scholarship" },
    // { id: "Ecards", label: "Ecards" },
    // { id: "ziprecruiter", label: "ziprecruiter" },
  ]

  const handleChangeSelect = (values) => {
    setPagination({
      ...pagination,
      source: values.length === allSources.length ? "" : values.join(","),
    })
  }

  const handleChangeCompanies = (values) => {
    setPagination({
      ...pagination,
      companyId: values.length === companies.length ? "" : values.join(","),
    })
  }

  return (
    <div className="z-50 flex flex-wrap items-start gap-3 mt-4">
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Home City
        </label>
        <input
          className="flex-1 px-3 py-2 text-sm"
          placeholder="Home City"
          type="text"
          value={pagination.homeCity}
          onChange={(e) =>
            setPagination({ ...pagination, homeCity: e.target.value })
          }
        />
      </div> */}
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Home State
        </label>
        <select
          onChange={handleChange}
          value={pagination.homeState}
          name="homeState"
          className={tabStyles.select}
        >
          <option value="">Select</option>
          {filterData?.home_state
            .filter((item) => item.HOME_STATE)
            .map((item) => (
              <option key={item.HOME_STATE} value={item.HOME_STATE}>
                {item.HOME_STATE}
              </option>
            ))}
        </select>
      </div> */}
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Home State
        </label>
        <input
      className="flex-1 px-3 py-2 text-sm"
      placeholder="Home State"
      type="text"
      value={pagination.homeState}
      onChange={(e) =>
        setPagination({ ...pagination, homeState: e.target.value })
      }
    />
    </div> */}

      <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Candidate Stage
        </label>
        <select
          onChange={handleChange}
          name="candidateStage"
          value={pagination.candidateStage}
          className={tabStyles.select}
        >
          <option value="">All</option>
          <option value="NEW CANDIDATE">NEW CANDIDATE</option>
          <option value="FOLLOW UP">FOLLOW UP</option>
          <option value="OUTREACH">OUTREACH</option>
          <option value="SCREENING">SCREENING</option>
          <option value="INTERVIEW">INTERVIEW</option>
          <option value="ONBOARDING">ONBOARDING</option>
          <option value="SALES LEADER ASSIGNMENT">
            SALES LEADER ASSIGNMENT
          </option>
          <option value="SALES LEADER INTERVIEW">SALES LEADER INTERVIEW</option>
          {/* <option value="BOOTCAMP">BOOTCAMP</option> */}
          {/* <option value="LEAD SET">LEAD SET</option>
          <option value="LEAD CLOSED">LEAD CLOSED</option> */}
        </select>
      </div>

      <div className="flex flex-col flex-1 flex-shrink-0 w-full gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Companies
        </label>

        <select
          onChange={handleChangeCompany}
          name="companyId"
          value={pagination.companyId}
          className={tabStyles.select}
        >
          <option>Select company</option>
          {companies.map((item) => (
            <option value={item.companyId}>{item.title}</option>
          ))}
        </select>
      </div>
      <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          AI First
        </label>
        <select
          onChange={(e) =>
            setPagination({ ...pagination, aiFirst: e.target.value })
          }
          name="aiFirst"
          value={pagination.aiFirst}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Screen Contact Attempt
        </label>
        <select
          onChange={(e) =>
            setPagination({
              ...pagination,
              screenContactAttempt: e.target.value,
            })
          }
          name="screenContactAttempt"
          value={pagination.screenContactAttempt}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option>
          <option value="4">4</option>
          <option value="5+">5+</option>
        </select>
      </div>
      <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Campaign Name
        </label>
        <select
          onChange={(e) =>
            setPagination({ ...pagination, campaignId: e.target.value })
          }
          name="campaignId"
          value={pagination.campaignId}
          className={tabStyles.select}
        >
          <option value="">All</option>
          {ads.map((item: any) => (
            <option value={item._id}>{item.campaignName}</option>
          ))}
        </select>
      </div>
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Companies
        </label>
        <select
          onChange={handleChangeCompany}
          name="companyId"
          value={pagination.companyId}
          className={tabStyles.select}
        >
          <option>Select</option>
          {companies.map((item) => (
            <option key={item.companyId} value={item.companyId}>
              {item.title}
            </option>
          ))}
        </select>
      </div> */}

      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Candidates
        </label>
        <select
          onChange={handleChange}
          name="leaderId"
          required
          value={pagination.leaderId}
          className={tabStyles.select}
        >
          <option>Select</option>
          {companyUsers.map((item: any) => (
            <option
              key={item._id}
              value={item.badgeId}
              data-fullname={item.fullname}
            >
              {item.fullname}
            </option>
          ))}
        </select>
      </div> */}
      <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Screening Filter
        </label>
        <select
          onChange={handleChange}
          name="acceptedCandidate"
          value={pagination.acceptedCandidate}
          className={tabStyles.select}
        >
          <option value="All">All</option>
          <option value="Accepted">Accepted</option>
          <option value="Rejected">Rejected</option>
          <option value="Follow up">Follow up</option>
          <option value="No answer">No Answer</option>
          <option value="Screening Only">Screening Only</option>
        </select>
      </div>

      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Evo Stage
        </label>
        <MultiSelectDropdown
          options={evoStages}
          onSelectionChange={(values) =>
            setPagination({
              ...pagination,
              evoStage:
                values.length === evoStages.length ? "" : values.join(","),
            })
          }
        />
      </div> */}

      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Outreach
        </label>
        <select
          onChange={handleChange}
          name="outreach"
          value={pagination.outreach}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          {filterData?.outreach
            .filter((item) => item.OUTREACH)
            .map((item) => (
              <option key={item.OUTREACH} value={item.OUTREACH}>
                {item.OUTREACH}
              </option>
            ))}
        </select>
      </div> */}
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Recuriting Category
        </label>
        <select
          onChange={handleChange}
          name="recruitingCategory"
          value={pagination.recruitingCategory}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          {filterData?.recruiting_category
            .filter((item) => item.RECRUITING_CATEGORY)
            .map((item) => (
              <option
                key={item.RECRUITING_CATEGORY}
                value={item.RECRUITING_CATEGORY}
              >
                {item.RECRUITING_CATEGORY}
              </option>
            ))}
        </select>
      </div> */}
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Recruting Location
        </label>
        <input
          className="flex-1 px-3 py-2 text-sm"
          placeholder="Recruiting Location"
          type="text"
          value={pagination.recruitingLocation}
          onChange={(e) =>
            setPagination({ ...pagination, recruitingLocation: e.target.value })
          }
        />
      </div> */}
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="text-xs text-gray-800 whitespace-nowrap ">
          Recruting Location
        </label>
        <select
          onChange={handleChange}
          name="recruitingLocation"
          value={pagination.recruitingLocation}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          {filterData?.recruiting_location
            .filter((item) => item.RECRUITING_LOCATION)
            .map((item) => (
              <option
                key={item.RECRUITING_LOCATION}
                value={item.RECRUITING_LOCATION}
              >
                {item.RECRUITING_LOCATION}
              </option>
            ))}
        </select>
      </div> */}

      <div className="flex flex-col flex-1 flex-shrink-0 w-full gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Source
        </label>
        <MultiSelectDropdown
          width="w-full"
          options={allSources}
          onSelectionChange={(values) => handleChangeSelect(values)}
        />
      </div>
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Source
        </label>
        <select
          onChange={handleChange}
          name="source"
          value={pagination.source}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          {["Breezy", "Acuity", "Elite", "Source", "Paid AD", "Infosession", "CampusReels", "Job Site Ad", "Indeed", "IndeedSponsored", "Scholarship", "Ecards", "ziprecruiter"]
            .map((item) => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
        </select>
      </div> */}
      {/* <div className="flex flex-col flex-1 gap-1 min-w-[150px]">
        <label className="field-label whitespace-nowrap">
          Source Category
        </label>
        <select
          onChange={handleChange}
          name="sourceCategory"
          value={pagination.sourceCategory}
          className={tabStyles.select}
        >
          <option value="">Select</option>
          {filterData?.source_category
            .filter((item) => item.SOURCE_CATEGORY)
            .map((item) => (
              <option key={item.SOURCE_CATEGORY} value={item.SOURCE_CATEGORY}>
                {item.SOURCE_CATEGORY}
              </option>
            ))}
        </select>
      </div> */}
    </div>
  )
}

const HeaderFilter = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  pagination,
  resetFilters,
  setPagination,
}) => {
  const filters = { ...pagination }
  delete filters.pageNumber
  delete filters.date
  delete filters.pageSize
  const hasFilters = Object.values(filters).some((item) => item)
  const [showCustom, setShowCustom] = useState(false)

  const handleChangeDates = (dates) => {
    const [start, end] = dates

    setStartDate(start)
    setEndDate(end)

    if (end) {
      setPagination({
        ...pagination,
        date: `${moment(start).format("YYYY-MM-DD")},${moment(end).format(
          "YYYY-MM-DD"
        )}`,
      })
    } else {
      setPagination({
        ...pagination,
        date: "",
      })
    }
  }

  return (
    <div className="flex items-center flex-1 gap-4 ">
      <input
        className="w-full px-3 py-2 text-sm"
        placeholder="Full Name"
        type="text"
        value={pagination.fullName}
        onChange={(e) =>
          setPagination({ ...pagination, fullName: e.target.value })
        }
      />
      <input
        className="w-full px-3 py-2 text-sm"
        placeholder="Email"
        type="text"
        value={pagination.email}
        onChange={(e) =>
          setPagination({ ...pagination, candidateEmail: e.target.value })
        }
      />
      <input
        className="w-full px-3 py-2 text-sm"
        placeholder="Phone Number"
        type="text"
        value={pagination.phoneNumber}
        onChange={(e) =>
          setPagination({ ...pagination, phoneNumber: e.target.value })
        }
      />
      <select
        className="px-4 py-2 text-sm font-light text-gray-800 border-gray-200 rounded-md focus:border-gray-300 focus:outline-none w-60 focus:ring-0"
        value={pagination.date}
        onChange={(e) => {
          if (e.target.value === "CUSTOM") {
            setShowCustom(true)
          } else {
            setPagination({
              ...pagination,
              date: e.target.value,
            })
          }
        }}
      >
        <option value="" disabled>
          Contact Created Date
        </option>
        {DATE.map((item) => (
          <option key={item} value={item}>
            {item}
          </option>
        ))}
      </select>

      {showCustom && (
        <DatePicker
          selected={startDate}
          placeholderText="Custom Date"
          onChange={handleChangeDates}
          startDate={startDate}
          endDate={endDate}
          // showIcon
          isClearable
          className="py-2 z-100"
          customInput={
            <input
              placeholder="Select date"
              className="px-3 py-2 text-sm"
            />
          }
          selectsRange
          selectsDisabledDaysInRange
        />
      )}

      {/* <div className="relative flex flex-col w-full gap-1">
        <label className="absolute left-0 text-xs text-gray-800 -top-4 whitespace-nowrap">
          From
        </label>
        <input
          className="w-full px-3 py-2 text-sm"
          type="date"
          onChange={(e) =>
            setPagination({ ...pagination, startDate: e.target.value })
          }
          name="startDate"
          value={pagination.startDate}
        />
      </div>
      <div className="relative flex flex-col w-full gap-1 ">
        <label className="absolute left-0 text-xs text-gray-800 -top-4 whitespace-nowrap">
          To
        </label>
        <input
          className="w-full px-3 py-2 text-sm"
          type="date"
          onChange={(e) =>
            setPagination({ ...pagination, endDate: e.target.value })
          }
          name="endDate"
          value={pagination.endDate}
        />
      </div> */}
      {hasFilters && (
        <button
          onClick={resetFilters}
          className="px-3 py-2 text-sm text-white bg-ink hover:bg-gray-800 rounded-lg whitespace-nowrap"
        >
          Clear Filters
        </button>
      )}
    </div>
  )
}

const tabStyles = {
  default:
    "tab",
  active: "tab-active",
  select:
    "w-full text-sm py-2 pl-3 pr-8",
  cellSelect:
    "bg-transparent px-3 text-sm rounded-md border-line appearance-none",
}
